import React from 'react';

interface StructuredDataProps {
  type: 'organization' | 'website' | 'localBusiness';
}

export default function StructuredData({ type }: StructuredDataProps) {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://subgen.net/#organization",
    "name": "DONG HOA AI DATA GENERATION LTD",
    "legalName": "DONG HOA AI DATA GENERATION LTD",
    "url": "https://subgen.net",
    "logo": "https://subgen.net/favicon/android-chrome-192x192.png",
    "foundingDate": "2025-09-10",
    "identifier": {
      "@type": "PropertyValue",
      "propertyID": "Companies House Number",
      "value": "NI733203"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Office 1334, 92 Castle Street",
      "addressLocality": "Belfast",
      "addressRegion": "Northern Ireland",
      "postalCode": "BT1 1HE",
      "addressCountry": "GB"
    },
    "contactPoint": [{
      "@type": "ContactPoint",
      "contactType": "customer support",
      "telephone": "+84911455879",
      "email": "ducnhatvo@gmail.com",
      "availableLanguage": ["vi", "en"],
      "areaServed": ["GB", "VN"]
    }],
    "sameAs": [
      "https://find-and-update.company-information.service.gov.uk/company/NI733203"
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://subgen.net/#website",
    "url": "https://subgen.net",
    "name": "DONG HOA AI DATA GENERATION LTD",
    "publisher": { "@id": "https://subgen.net/#organization" },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://subgen.net/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": "https://subgen.net/#localBusiness",
    "name": "DONG HOA AI DATA GENERATION LTD",
    "legalName": "DONG HOA AI DATA GENERATION LTD",
    "url": "https://subgen.net",
    "logo": "https://subgen.net/favicon/android-chrome-192x192.png",
    "description": "AI-powered subtitle generation and video translation services",
    "foundingDate": "2025-09-10",
    "identifier": {
      "@type": "PropertyValue",
      "propertyID": "Companies House Number",
      "value": "NI733203"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Office 1334, 92 Castle Street",
      "addressLocality": "Belfast",
      "addressRegion": "Northern Ireland",
      "postalCode": "BT1 1HE",
      "addressCountry": "GB"
    },
    "contactPoint": [{
      "@type": "ContactPoint",
      "contactType": "customer support",
      "telephone": "+84911455879",
      "email": "ducnhatvo@gmail.com",
      "availableLanguage": ["vi", "en"],
      "areaServed": ["GB", "VN"]
    }],
    "sameAs": [
      "https://find-and-update.company-information.service.gov.uk/company/NI733203"
    ],
    "serviceArea": {
      "@type": "Country",
      "name": "United Kingdom"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "AI Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "AI Subtitle Generation",
            "description": "Automatic subtitle generation for videos using AI technology"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Video Translation",
            "description": "AI-powered video translation and subtitle services"
          }
        }
      ]
    }
  };

  const getSchema = () => {
    switch (type) {
      case 'organization':
        return organizationSchema;
      case 'website':
        return websiteSchema;
      case 'localBusiness':
        return localBusinessSchema;
      default:
        return organizationSchema;
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(getSchema(), null, 2)
      }}
    />
  );
}
